import { memo, type FC } from "react";
import { useTranslation } from "react-i18next";
import type { CampaignChannel } from "../../EngagementInterfaces";
import { CAMPAIGN_CHANNEL_OPTIONS } from "./CampaignSetupConstants";

interface ChannelSelectorProps {
  value: CampaignChannel | null;
  onChange: (_channel: CampaignChannel) => void;
  labelledBy?: string;
  onlySelected?: boolean;
}

const ChannelSelector: FC<ChannelSelectorProps> = ({
  value,
  onChange,
  labelledBy,
  onlySelected = false,
}) => {
  const { t } = useTranslation();
  const options = onlySelected
    ? CAMPAIGN_CHANNEL_OPTIONS.filter(option => option.value === value)
    : CAMPAIGN_CHANNEL_OPTIONS;

  return (
    <div className="campaign-channel-selector" role="radiogroup"
      aria-labelledby={labelledBy}
      aria-readonly={onlySelected || undefined}
    >
      {options.map(({ value: optionValue, labelKey, Icon }) => {
        const isSelected = optionValue === value;

        return (
          <button
            key={optionValue}
            type="button"
            role="radio"
            aria-checked={isSelected}
            className={`campaign-channel-selector__option ${
              isSelected ? "campaign-channel-selector__option--selected" : ""
            }`}
            onClick={() => onChange(optionValue)}
          >
            <Icon className="campaign-channel-selector__icon" />
            <span>{t(labelKey)}</span>
          </button>
        );
      })}
    </div>
  );
};

export default memo(ChannelSelector);
